import { BrandEntity, BrandEntityId } from "@common/domain";
import { createAction, props } from "@ngrx/store";
import {
  RoomBrandCreateVO,
  RoomBrandDeleteVO,
  RoomBrandUpdateVO,
  RoomBrandUseVO
} from "@youm-front/room/domain";

export const roomBrandCreate = createAction(
  "[Room] Room Brand Create",
  props<{ roomBrandCreateVO: RoomBrandCreateVO }>()
);
export const roomBrandCreateSuccess = createAction(
  "[Room] Room Brand Create Success",
  props<{ brand: BrandEntity }>()
);
export const roomBrandCreateFailure = createAction(
  "[Room] Room Brand Create Failure",
  props<{ error: string }>()
);

export const roomBrandDelete = createAction(
  "[Room] Room Brand Delete",
  props<{ roomBrandDeleteVO: RoomBrandDeleteVO }>()
);
export const roomBrandDeleteSuccess = createAction(
  "[Room] Room Brand Delete Success",
  props<{ brandId: BrandEntityId }>()
);
export const roomBrandDeleteFailure = createAction(
  "[Room] Room Brand Delete Failure",
  props<{ error: string }>()
);

export const roomBrandUpdate = createAction(
  "[Room] Room Brand Update",
  props<{ roomBrandUpdateVO: RoomBrandUpdateVO }>()
);
export const roomBrandUpdateSuccess = createAction(
  "[Room] Room Brand Update Success",
  props<{ brand: BrandEntity }>()
);
export const roomBrandUpdateFailure = createAction(
  "[Room] Room Brand Update Failure",
  props<{ error: string }>()
);

export const roomBrandUse = createAction(
  "[Room] Room Brand Use",
  props<{ roomBrandUseVO: RoomBrandUseVO }>()
);
export const roomBrandUseSuccess = createAction(
  "[Room] Room Brand Use Success",
  props<{ roomBrandUseVO: RoomBrandUseVO }>()
);
export const roomBrandUseFailure = createAction(
  "[Room] Room Brand Use Failure",
  props<{ error: string }>()
);
